import React, { useEffect, useRef, useState } from 'react';
import {
  Container,
  TextField,
  Button,
  Box,
  Typography,
  Paper,
  IconButton,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  useMediaQuery,
  useTheme,
  CircularProgress,
  Backdrop,
  Dialog,
  DialogContent,
} from '@mui/material';
import {
  MdArrowBackIos,
  MdCameraAlt,
  MdClose,
  MdFlipCameraAndroid,
  MdFlipCameraIos,
  MdHome,
  MdOutlineFileUpload,
} from 'react-icons/md';
import { FaImage } from 'react-icons/fa6';
import {
  filter,
  find,
  findIndex,
  flatMap,
  includes,
  isEmpty,
  last,
  map,
  omit,
  partition,
  split,
  startsWith,
  sum,
  trim,
  uniq,
  uniqBy,
} from 'lodash';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaTruck } from 'react-icons/fa';
import Webcam from 'react-webcam';
import itemDeliveryService from '../../services/itemDeliveryService';
import fileUploadService from '../../services/fileUploadService';
import { UserHeader } from '../../components/AdminHeader';
import Footer from '../../components/Footer';
import { ImageModal } from '../supervisor/SupervisorForm';
import {
  base64ToFile,
  dataURLtoFile,
  getAddressFromCoords,
  isBase64Image,
  resizeImage,
} from '../../common';
import { IoCamera } from 'react-icons/io5';
import { CgSoftwareUpload } from 'react-icons/cg';
import departmentService from '../../services/departmentService';
import axios from 'axios';

const OutWardItem = () => {
  const navigate = useNavigate();
  const webcamRef = useRef();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedFile, setSelectedFile] = useState(null);
  const [capturePhoto, setCapturePhoto] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [imageUploading, setImageLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [balanceError, setBalanceError] = useState(false); // Track balance error
  const [departments, setDepartments] = useState([]);
  const [itemTypes, setItemTypes] = useState([]);
  const [items, setItems] = useState([]);
  const [itemDeliveries, setItemDeliveries] = useState([]);
  const [allocations, setAllocations] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [openModal, setOpenModal] = useState(false); // Modal visibility state
  const [selectedImage, setSelectedImage] = useState(null); // Store the item to be edited
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [loading, setLoading] = useState(false);
  const station = localStorage?.getItem('stations')
    ? JSON.parse(localStorage?.getItem('stations'))
    : [];
  const [localPhotos, setLocalPhotos] = useState({});
  const [facingMode, setFacingMode] = useState('environment');

  const products = localStorage?.getItem('products')
    ? JSON.parse(localStorage?.getItem('products'))
    : [];

  const toggleCamera = () => {
    setFacingMode((prevMode) => (prevMode === 'user' ? 'environment' : 'user'));
  };

  const fetchItemDeliveries = async () => {
    try {
      setLoading(true);

      const response = await itemDeliveryService.getItemByStation(
        selectedDepartment
      );

      console.log('response', response.data);

      const responseData = filter(response.data, (data) =>
        includes(products, data?.item_name)
      );

      setItemDeliveries(
        filter(
          responseData,
          (data) =>
            // data?.station === selectedDepartment &&
            data?.event_id === parseInt(localStorage?.getItem('event_id')) &&
            data?.allocated_qty !== 0
        )
      );
    } catch (error) {
      console.error('Error fetching item deliveries:', error);
    } finally {
      setLoading(false);
    }
  };

  // const fetchItemDeliveries = async () => {
  //   try {
  //     setLoading(true);

  //     const response = await itemDeliveryService.getItemDeliveriesDetails();
  //     const responseData = filter(response.data, (data) =>
  //       includes(products, data?.item_name)
  //     );

  //     if (selectedDepartment) {
  //       setItemDeliveries(
  //         filter(
  //           responseData,
  //           (data) =>
  //             data?.station === selectedDepartment &&
  //             data?.event_id === parseInt(localStorage?.getItem('event_id')) &&
  //             data?.allocated_qty !== 0
  //         )
  //       );
  //     } else {
  //       const array = filter(
  //         responseData,
  //         (data) =>
  //           includes(station, data?.station) &&
  //           data?.event_id === parseInt(localStorage?.getItem('event_id'))
  //       );
  //       setDepartments(uniqBy(array, 'station'));
  //     }
  //   } catch (error) {
  //     console.error('Error fetching item deliveries:', error);
  //   } finally {
  //     setLoading(false); // stop loading
  //   }
  // };

  // const fetchItemDeliveries = async () => {
  //   const response = await itemDeliveryService.getItemDeliveriesDetails();
  //   const responseData = filter(response.data, (data) =>
  //     includes(products, data?.item_name)
  //   );
  //   if (selectedDepartment) {
  //     setItemDeliveries(
  //       filter(
  //         responseData,
  //         (data) =>
  //           data?.station === selectedDepartment &&
  //           data?.event_id === parseInt(localStorage?.getItem('event_id')) &&
  //           data?.allocated_qty !== 0
  //       )
  //     );
  //   } else {
  //     const array = filter(
  //       responseData,
  //       (data) =>
  //         includes(station, data?.station) &&
  //         data?.event_id === parseInt(localStorage?.getItem('event_id'))
  //     );
  //     setDepartments(uniqBy(array, 'station'));
  //   }
  // };

  const getDepartments = async () => {
    const response = await departmentService?.getDepartmentByUserId(
      localStorage?.getItem('user_id')
    );

    if (response?.status === 200) {
      setDepartments(response?.data?.stations);
    }
  };

  useEffect(() => {
    getDepartments();

    const handleSuccess = (position) => {
      const { latitude, longitude } = position.coords;
      setLocation({ latitude, longitude });
    };

    const handleError = (error) => {
      console?.error('Geolocation is not supported by this browser.');
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(handleSuccess, handleError);
    } else {
      console?.error('Geolocation is not supported by this browser.');
    }
  }, []);

  useEffect(() => {
    if (selectedDepartment) {
      fetchItemDeliveries();
    }
    setAllocations([]);
  }, [selectedDepartment]);

  console.log('data?.id', allocations, itemDeliveries, selectedDepartment);

  const handleSubmit = async () => {
    // const photosToAdd = Array.isArray(file) ? file : [file];

    const data = {
      user_id: parseInt(localStorage?.getItem('user_id')),
      updates: map(
        map(uniqBy(allocations, 'id'), (data) => {
          return {
            ...data,
            // photo: data.photo
            //   ? `${data.photo}, ${photosToAdd.join(', ')}`
            //   : photosToAdd.join(', '),
            remarks: 'delivered',
            // station: selectedDepartment,
            station_type: data?.station_type,
            // latitude: location?.latitude,
            // longitude: location?.longitude,
          };
        }),
        (allocation) =>
          omit(allocation, [
            'timestamp',
            'entered_qty',
            'department_name',
            'user_name',
            'item_name',
            'event_name',
            'delivered_date',
            'station',
          ])
      ),
    };

    console.log('data?.id', data);

    try {
      const res = await itemDeliveryService?.updateItemDelivery(
        selectedDepartment,
        data
      );
      if (res?.status === 200) {
        toast?.success('Data submitted successfully.');
        setFile(null);
        // setSelectedDepartment('');
        setAllocations([]);
        setCapturePhoto(false);
        // setBalanceError(false);
        setItemDeliveries([]);
        fetchItemDeliveries();
        setLocalPhotos({});
        // setItems([]);
      }
    } catch (e) {
      toast.error(e?.response?.data?.message);
    }
  };

  const handleInputChange = (id, value, item, uploadedPhoto) => {
    const photosToAdd = Array.isArray(uploadedPhoto)
      ? uploadedPhoto
      : [uploadedPhoto];

    const quantity = value
      ? parseInt(value, 10)
      : find(allocations, { id: parseInt(id) })
      ? find(allocations, { id: parseInt(id) })?.delivered_qty
      : 0;

    const newAllocation = {
      ...item,
      delivered_qty: quantity,
      picked_qty: 0,
      photo: uploadedPhoto
        ? item?.photo
          ? `${item?.photo}, ${photosToAdd.join(', ')}`
          : photosToAdd.join(', ')
        : '',
    };

    const existingIndex = findIndex(allocations, { id: id });

    if (existingIndex >= 0) {
      const updatedAllocations = [...allocations];
      updatedAllocations[existingIndex] = newAllocation;
      setAllocations(updatedAllocations);
    } else {
      setAllocations([...allocations, newAllocation]);
    }
  };

  console.log('item.photo', allocations);

  const getLineColor = (index) => {
    const colors = ['#469289', '#B29939', '#2B5786', '#66933F']; // Color sequence
    return colors[index % 3]; // Cycle through colors based on index
  };

  const handleCapturePhoto = async () => {
    try {
      setImageLoading(true);

      const imageSrc = webcamRef.current.getScreenshot();
      if (!imageSrc) throw new Error('Failed to capture image from webcam.');

      // Get geolocation coordinates
      const coords = await new Promise((resolve, reject) =>
        navigator.geolocation.getCurrentPosition(
          (pos) => resolve(pos.coords),
          (err) => reject(new Error('Unable to get location: ' + err.message))
        )
      );

      // Get address
      const address = await getAddressFromCoords(
        coords.latitude,
        coords.longitude
      );

      const img = new Image();
      img.src = imageSrc;

      img.onload = async () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');

          // Draw original image
          ctx.drawImage(img, 0, 0);

          // Lines to display
          const lines = [
            address,
            `Lat: ${coords.latitude.toFixed(
              5
            )} | Lng: ${coords.longitude.toFixed(5)}`,
            new Date().toLocaleString(),
          ];

          const padding = 10;
          const lineHeight = 18;
          const mapWidth = isMobile ? 140 : 200;
          const textWidth = canvas.width - mapWidth - padding * 3;
          const boxHeight = Math.max(
            lineHeight * lines.length + padding * 2,
            100
          );
          const y = canvas.height - boxHeight;

          // Draw background box
          ctx.fillStyle = 'rgba(0,0,0,0.7)';
          ctx.fillRect(0, y, canvas.width, boxHeight);

          // Load static Google map
          const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${coords.latitude},${coords.longitude}&zoom=14&size=${mapWidth}x${boxHeight}&markers=color:red%7C${coords.latitude},${coords.longitude}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;

          const mapImg = new Image();
          mapImg.crossOrigin = 'Anonymous';
          mapImg.src = staticMapUrl;

          mapImg.onload = () => {
            try {
              const mapBottomPadding = 10;
              ctx.drawImage(
                mapImg,
                padding,
                y,
                mapWidth,
                boxHeight - mapBottomPadding
              );

              // Draw wrapped text
              ctx.fillStyle = 'white';
              ctx.font = isMobile ? '10px Arial' : '16px Arial';
              ctx.textAlign = 'left';
              const textX = mapWidth + padding * 2;
              let textY = y + padding;

              lines.forEach((line) => {
                const words = line.split(' ');
                let lineText = '';
                words.forEach((word) => {
                  const testLine = lineText + word + ' ';
                  const metrics = ctx.measureText(testLine);
                  if (metrics.width > textWidth) {
                    ctx.fillText(lineText, textX, textY);
                    lineText = word + ' ';
                    textY += lineHeight;
                  } else {
                    lineText = testLine;
                  }
                });
                ctx.fillText(lineText, textX, textY);
                textY += lineHeight;
              });

              // Export stamped image
              const stampedDataURL = canvas.toDataURL('image/jpeg');
              const stampedFile = dataURLtoFile(
                stampedDataURL,
                `Delivered_photo_${Date.now()}.jpg`
              );
              handleFileChange(stampedFile);
            } catch (innerErr) {
              console.error('❌ Error while drawing map or text:', innerErr);
              alert('Failed to process image overlay.');
            }
          };

          // Map load error fallback
          mapImg.onerror = (e) => {
            console.warn('⚠️ Map failed to load:', e);

            // Draw only text (no map)
            ctx.fillStyle = 'white';
            ctx.font = isMobile ? '10px Arial' : '16px Arial';
            ctx.textAlign = 'left';
            let textY = y + padding;
            lines.forEach((line) => {
              ctx.fillText(line, padding * 2, textY);
              textY += lineHeight;
            });

            const stampedDataURL = canvas.toDataURL('image/jpeg');
            const stampedFile = dataURLtoFile(
              stampedDataURL,
              `Delivered_photo_${Date.now()}.jpg`
            );
            handleFileChange(stampedFile);
          };
        } catch (processErr) {
          console.error('❌ Error processing image:', processErr);
          alert('Failed to process image. Please try again.');
        }
      };

      img.onerror = () => {
        throw new Error('Failed to load captured image.');
      };
    } catch (err) {
      console.error('❌ Error capturing photo:', err);
      alert(
        err.message ||
          'Unable to capture photo. Please check camera or location permissions.'
      );
      setImageLoading(false);
      setSelectedItem({});
    }
  };

  // const handleCapturePhoto = async () => {
  //   try {
  //     const imageSrc = webcamRef.current.getScreenshot();

  //     const coords = await new Promise((resolve, reject) =>
  //       navigator.geolocation.getCurrentPosition(
  //         (pos) => resolve(pos.coords),
  //         reject
  //       )
  //     );

  //     const address = await getAddressFromCoords(
  //       coords.latitude,
  //       coords.longitude
  //     );

  //     const img = new Image();
  //     img.src = imageSrc;

  //     img.onload = async () => {
  //       const canvas = document.createElement('canvas');
  //       canvas.width = img.width;
  //       canvas.height = img.height;
  //       const ctx = canvas.getContext('2d');

  //       ctx.drawImage(img, 0, 0);

  //       const lines = [
  //         address,
  //         `Lat: ${coords.latitude.toFixed(5)} | Lng: ${coords.longitude.toFixed(
  //           5
  //         )}`,
  //         new Date().toLocaleString(),
  //       ];

  //       ctx.font = isMobile ? '10px Arial' : '16px Arial';
  //       const padding = 10;
  //       const lineHeight = 18;
  //       const mapWidth = 200;
  //       const textWidth = canvas.width - mapWidth - padding * 3;
  //       const boxHeight = Math.max(
  //         lineHeight * lines.length + padding * 2,
  //         100
  //       );
  //       const y = canvas.height - boxHeight;

  //       ctx.fillStyle = 'rgba(0,0,0,0.7)';
  //       ctx.fillRect(0, y, canvas.width, boxHeight);

  //       const drawText = () => {
  //         ctx.fillStyle = 'white';
  //         ctx.textAlign = 'left';
  //         const textX = mapWidth + padding * 2;
  //         let textY = y + padding;

  //         lines.forEach((line) => {
  //           const words = line.split(' ');
  //           let lineText = '';
  //           words.forEach((word) => {
  //             const testLine = lineText + word + ' ';
  //             const metrics = ctx.measureText(testLine);
  //             if (metrics.width > textWidth) {
  //               ctx.fillText(lineText, textX, textY);
  //               lineText = word + ' ';
  //               textY += lineHeight;
  //             } else {
  //               lineText = testLine;
  //             }
  //           });
  //           ctx.fillText(lineText, textX, textY);
  //           textY += lineHeight;
  //         });
  //       };

  //       const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${coords.latitude},${coords.longitude}&zoom=14&size=${mapWidth}x${boxHeight}&markers=color:red%7C${coords.latitude},${coords.longitude}&key=YOUR_API_KEY`;
  //       const mapImg = new Image();
  //       mapImg.crossOrigin = 'Anonymous';
  //       mapImg.src = staticMapUrl;

  //       let mapLoaded = false;
  //       let finalized = false; // <-- ✅ Flag to prevent double calls

  //       const finalizeImage = () => {
  //         if (finalized) return; // ✅ Prevent multiple calls
  //         finalized = true;

  //         if (!mapLoaded) {
  //           console.warn(
  //             '⚠️ Map failed to load — proceeding without map overlay.'
  //           );
  //         }

  //         drawText();

  //         const stampedDataURL = canvas.toDataURL('image/jpeg');
  //         const stampedFile = dataURLtoFile(
  //           stampedDataURL,
  //           `Delivered_photo_${Date.now()}.jpg`
  //         );

  //         // stampedFile.fullMapUrl = `https://www.google.com/maps/search/?api=1&query=${coords.latitude},${coords.longitude}`;

  //         handleFileChange(stampedFile);
  //       };

  //       mapImg.onload = () => {
  //         mapLoaded = true;
  //         const mapBottomPadding = 10;
  //         ctx.drawImage(
  //           mapImg,
  //           padding,
  //           y,
  //           mapWidth,
  //           boxHeight - mapBottomPadding
  //         );
  //         finalizeImage();
  //       };

  //       mapImg.onerror = finalizeImage;

  //       // Safety timeout
  //       setTimeout(() => {
  //         if (!mapLoaded) finalizeImage();
  //       }, 4000);
  //     };
  //   } catch (err) {
  //     console.error('❌ Error capturing photo:', err);
  //     alert(
  //       'Unable to capture photo. Please check camera or location permissions.'
  //     );
  //   }
  // };

  // const handleFileChange = async (file, uploadPhoto) => {
  //   const res = await fileUploadService?.handleFileUpload(file);
  //   if (res?.status === 200) {
  //     setFile(res?.data?.filename);
  //     toast?.success(
  //       `Photo ${uploadPhoto ? 'uploaded' : 'captured'} successfully`
  //     );
  //     setCapturePhoto(false);
  //   }
  // };

  // const handleFileChange = async (file, uploadPhoto, item) => {
  //   const obj = !isEmpty(item) ? item : selectedItem;
  //   const normalizedName = file.name.replace(/^delivered_photo_/i, '');

  //   try {
  //     setImageLoading(true);

  //     const res = await fileUploadService?.handleFileUpload(
  //       new File([file], `Delivered_photo_${normalizedName}`, {
  //         type: file.type,
  //       })
  //     );

  //     if (res?.status === 200) {
  //       const filename = startsWith(res?.data?.filename, 'Delivered_photo_')
  //         ? res?.data?.filename
  //         : `Delivered_photo_${res?.data?.filename}`;
  //       setFile(filename);
  //       handleInputChange(obj?.id, '', obj, filename);
  //       toast?.success(
  //         `Photo ${uploadPhoto ? 'uploaded' : 'captured'} successfully`
  //       );
  //       setCapturePhoto(false);
  //     } else {
  //       toast?.error('Failed to upload photo');
  //     }
  //   } catch (error) {
  //     console.error('Error uploading file:', error);
  //     if (!error?.response && isMobile) {
  //       toast.error(
  //         'Use the upload option only for file uploads, and use a separate capture button to take photos.'
  //       );
  //     } else if (error?.response?.data?.message) {
  //       toast.error(error.response.data.message);
  //     } else {
  //       toast.error('Something went wrong while uploading');
  //     }
  //   } finally {
  //     setImageLoading(false);
  //     setSelectedItem({});
  //   }
  // };

  // const handleFileChange = async (input, uploadPhoto, item) => {
  //   let file = input;

  //   if (isBase64Image(input)) {
  //     file = base64ToFile(input);
  //   }

  //   if (file.size > 2 * 1024 * 1024) {
  //     file = await resizeImage(file);
  //   }

  //   const obj = !isEmpty(item) ? item : selectedItem;
  //   const normalizedName = file.name.replace(/^delivered_photo_/i, '');

  //   try {
  //     setImageLoading(true);

  //     const res = await fileUploadService.handleFileUpload(
  //       file
  //       // new File([file], `Delivered_photo_${normalizedName}`, {
  //       //   type: file.type,
  //       // })
  //     );

  //     if (res?.status === 200) {
  //       const filename = res.data.filename.startsWith('Delivered_photo_')
  //         ? res.data.filename
  //         : `Delivered_photo_${res.data.filename}`;

  //       setFile(filename);
  //       handleInputChange(obj?.id, '', obj, filename);

  //       toast.success(
  //         `Photo ${uploadPhoto ? 'uploaded' : 'captured'} successfully`
  //       );
  //       setCapturePhoto(false);
  //     } else {
  //       toast.error('Failed to upload photo');
  //     }
  //   } catch (error) {
  //     console.error('Error uploading file:', error);

  //     if (!error?.response && isMobile) {
  //       toast.error(
  //         'Use the upload option only for file uploads, and use a separate capture button to take photos.'
  //       );
  //     } else if (error?.response?.data?.message) {
  //       toast.error(error.response.data.message);
  //     } else {
  //       toast.error('Something went wrong while uploading');
  //     }
  //   } finally {
  //     setImageLoading(false);
  //     setSelectedItem({});
  //   }
  // };

  const handleFileChange = async (input, uploadPhoto, item) => {
    let file = input;

    if (isBase64Image(input)) {
      file = base64ToFile(input);
    }

    if (file?.size > 2 * 1024 * 1024) {
      file = await resizeImage(file);
    }

    const obj = !isEmpty(item) ? item : selectedItem;
    const normalizedName = file.name.replace(/^delivered_photo_/i, '');

    try {
      setImageLoading(true);
      const res = await fileUploadService.handleFileUpload(
        new File([file], `Delivered_photo_${normalizedName}`, {
          type: file.type,
        })
      );

      if (res?.status === 200) {
        const filename = res.data.filename.startsWith('Delivered_photo_')
          ? res.data.filename
          : `Delivered_photo_${res.data.filename}`;

        setFile(filename);
        setLocalPhotos((prev) => ({
          ...prev,
          [obj.id]: filename,
        }));
        handleInputChange(obj?.id, '', obj, filename);

        toast.success(
          `Photo ${uploadPhoto ? 'uploaded' : 'captured'} successfully`
        );
        setCapturePhoto(false);
      } else {
        toast.error('Failed to upload photo');
      }
    } catch (error) {
      console.error('Error uploading file:', error);

      if (!error?.response && isMobile) {
        toast.error(
          'Please Use the upload option only for file uploads, and use a separate capture button to capture photos.'
        );
      } else if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error('Something went wrong while uploading');
      }
    } finally {
      setImageLoading(false);
      setSelectedItem({});
    }
  };

  /* =======================
   Upload Handler
======================= */

  // const handleFileChange = async (input) => {
  //   if (!input) return;

  //   let file = input;

  //   // Base64 → File
  //   if (isBase64Image(input)) {
  //     file = base64ToFile(input);
  //   }

  //   // Compress large images (camera)
  //   if (file.size > 2 * 1024 * 1024) {
  //     file = await resizeImage(file);
  //   }

  //   const formData = new FormData();
  //   formData.append('file', file);

  //   // IMPORTANT: no Content-Type header
  //   return axios.post(`${API_URL}/common/secureFileUpload`, formData)?.then((res) => {
  //     if(res?.status === 200){
  //       toast.success('File Uploaded successfully')
  //     }else{
  //       toast.error('Something')
  //     }
  //   })
  // };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedImage(null);
  };

  return (
    <Container
      maxWidth='sm'
      sx={{
        pt: 2,
        bgcolor: '#f9f9f9',
        p: '0 !important',
        borderRadius: 2,
        p: 2,
        minHeight: '100vh',
        maxHeight: 'fit-content',
      }}
    >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
      <Paper
        elevation={3}
        sx={{
          padding: '16px',
          maxHeight: 'fit-content',
          minHeight: '100vh',
        }}
      >
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Typography
            sx={{
              display: 'flex',
              alignItems: 'center',
              fontSize: '1rem',
              color: '#333',
              fontWeight: 550,
            }}
          >
            <FaTruck size={20} fill='#0d970d' style={{ marginRight: '8px' }} />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                textDecoration: 'underline',
                fontSize: '1.1rem',
              }}
            >
              INWARD DELIVERY
            </div>
          </Typography>
        </Box>

        <Box component='form' sx={{ mt: 2 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              variant='body2'
              sx={{ fontWeight: 700, fontSize: '1rem' }}
            >
              SELECT STATION
            </Typography>
            <Select
              name='department_id'
              value={selectedDepartment}
              fullWidth
              onChange={(e) => {
                setSelectedDepartment(e?.target?.value);
                setItemDeliveries([]);
                setAllocations([]);
                setSelectedItem({});
                setFile(null);
              }}
              variant='outlined'
            >
              {!isEmpty(departments) ? (
                map(departments, (station) => (
                  <MenuItem key={station} value={station}>
                    {station}
                  </MenuItem>
                ))
              ) : (
                <MenuItem>No data found</MenuItem>
              )}
            </Select>
            {!selectedDepartment && (
              <Typography
                variant='caption'
                color='error'
                sx={{ fontSize: '0.7rem' }}
              >
                Station is required
              </Typography>
            )}
          </Box>
          {selectedDepartment && (
            <Box sx={{ mt: 2 }}>
              {itemDeliveries?.map((item, index) => {
                const enteredValue =
                  item.entered_qty !== undefined &&
                  item.entered_qty !== null &&
                  item.entered_qty !== ''
                    ? item?.entered_qty
                    : item?.delivered_qty; // Default to 0 only if no value has been entered

                const remainingQty = item.allocated_qty - enteredValue;

                const deliveredQty =
                  find(allocations, {
                    id: parseInt(item?.id),
                  })?.delivered_qty ||
                  find(allocations, {
                    id: parseInt(item?.id),
                  })?.entered_qty;

                // const itemPhoto = find(allocations, {
                //   id: parseInt(item?.id),
                // })?.photo
                //   ? last(
                //       map(
                //         split(
                //           find(allocations, {
                //             id: parseInt(item?.id),
                //           })?.photo,
                //           ','
                //         ),
                //         trim
                //       )
                //     )
                //   : '';

                const itemPhoto =
                  localPhotos[item.id] ||
                  (find(allocations, { id: parseInt(item?.id) })?.photo
                    ? last(
                        map(
                          split(
                            find(allocations, { id: parseInt(item?.id) })
                              ?.photo,
                            ','
                          ),
                          trim
                        )
                      )
                    : '');

                console.log('itemPhoto', itemPhoto);

                return (
                  <Box key={item.id}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        padding: '0.6rem',
                        borderBottom: '1px solid grey.300',
                        backgroundColor: '#f9f9f9', // Optional background color
                        position: 'relative',
                      }}
                    >
                      {/* Vertical Line for Card */}
                      <Box
                        sx={{
                          width: '4px',
                          height: '100%',
                          borderTopLeftRadius: '0.8rem',
                          borderBottomLeftRadius: '0.8rem',
                          backgroundColor: getLineColor(index), // Dynamic color based on itemType
                          position: 'absolute',
                          left: 0,
                          top: 0,
                        }}
                      />

                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          width: '100%',
                          gap: 2,
                        }}
                      >
                        {/* Left Section */}
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            pl: '1rem',
                            '@media (max-width: 600px)': {
                              width: '40%', // Full width on mobile
                            },
                          }}
                        >
                          <Typography
                            variant='body1'
                            sx={{ fontWeight: 'bold', fontSize: '1rem' }}
                          >
                            {item?.item_name}
                          </Typography>
                          <Typography
                            variant='caption'
                            sx={{
                              mt: 0.5,
                              fontWeight: 'bold',
                              fontSize: '0.75rem',
                              color: 'grey.600',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            ALLOTED: {item?.allocated_qty}
                          </Typography>
                          <Typography
                            variant='caption'
                            sx={{
                              mt: 0.5,
                              fontWeight: 'bold',
                              fontSize: '0.7rem',
                              color: 'grey.600',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            PREV DELIVERED: {item?.delivered_qty}
                          </Typography>
                          <Typography
                            variant='caption'
                            sx={{
                              mt: 0.5,
                              fontWeight: 'bold',
                              fontSize: '0.7rem',
                              color: 'grey.600',
                            }}
                          >
                            BALANCE: {remainingQty}
                          </Typography>
                        </Box>

                        {/* Right Section */}
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'center',
                            flexDirection: 'column',
                            // flexDirection: isMobile ? 'column' : 'row',
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'flex-end',
                              gap: '0.5rem',
                              '@media (max-width: 600px)': {
                                width: '60%', // Full width on mobile
                              },
                            }}
                          >
                            <Typography
                              variant='caption'
                              sx={{
                                fontWeight: 520,
                                fontSize: '0.7rem',
                              }}
                            >
                              CURR DELIVERED QTY
                            </Typography>

                            <TextField
                              type='number'
                              // disabled={
                              //   item?.allocated_qty === item?.delivered_qty
                              // }
                              onChange={(e) => {
                                // const newValue = sum([
                                //   item?.delivered_qty,
                                //   Number(e.target.value),
                                // ]);

                                const newValue = Number(e.target.value);

                                handleInputChange(
                                  item.id,
                                  newValue,
                                  item,
                                  find(allocations, {
                                    id: parseInt(item?.id),
                                  })?.photo
                                );
                                item.entered_qty = newValue;
                              }}
                              variant='outlined'
                              size='small'
                              sx={{
                                width: '80px',
                                '& .MuiOutlinedInput-root': {
                                  // backgroundColor:
                                  //   item?.allocated_qty === item?.delivered_qty
                                  //     ? '#f0f0f0'
                                  //     : 'transparent',
                                },
                                '& .MuiInputBase-input': {
                                  // cursor:
                                  //   item?.allocated_qty === item?.delivered_qty
                                  //     ? 'not-allowed'
                                  //     : 'auto',
                                },
                                '& .MuiOutlinedInput-root.Mui-disabled': {
                                  backgroundColor: '#f0f0f0',
                                },
                                '& .MuiOutlinedInput-input': {
                                  textAlign: 'right',
                                },
                              }}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              // gap: isMobile ? 1.5 : 0.5,
                              // pt: isMobile ? 0 : 3,
                              gap: 1,
                              width: '100%',
                              justifyContent: 'flex-end',
                            }}
                          >
                            {!capturePhoto && (
                              <IoCamera
                                onClick={() => {
                                  if (
                                    !deliveredQty ||
                                    deliveredQty === 0 ||
                                    deliveredQty < 0
                                  ) {
                                    toast.error('Please enter the qty first');
                                    return;
                                  } else {
                                    setCapturePhoto(true);
                                    setSelectedItem(item);
                                  }
                                }}
                                disabled={
                                  !selectedDepartment ||
                                  isEmpty(itemDeliveries) ||
                                  imageUploading
                                }
                                id={`capture-photo-${item.id}`}
                                fill='#2090ff'
                                cursor='pointer'
                                size={22}
                              />
                            )}
                            <>
                              <input
                                accept='image/*'
                                style={{ display: 'none' }}
                                id={`upload-file-${item.id}`} // unique per product/item
                                type='file'
                                onChange={(e) => {
                                  if (
                                    !deliveredQty ||
                                    deliveredQty === 0 ||
                                    deliveredQty < 0
                                  ) {
                                    toast.error('Please enter the qty first');
                                  } else {
                                    handleFileChange(
                                      e?.target?.files?.[0],
                                      true,
                                      item
                                    );
                                  }
                                }}
                              />
                              {/* Upload button */}
                              <CgSoftwareUpload
                                disabled={
                                  isEmpty(itemDeliveries) || imageUploading
                                }
                                color='red'
                                cursor='pointer'
                                size={24}
                                onClick={() => {
                                  if (
                                    !deliveredQty ||
                                    deliveredQty === 0 ||
                                    deliveredQty < 0
                                  ) {
                                    toast.error('Please enter the qty first');
                                  } else {
                                    document
                                      .getElementById(`upload-file-${item.id}`)
                                      ?.click();
                                  }
                                }}
                              />
                            </>
                            {itemPhoto && (
                              <Box>
                                <Typography
                                  variant='subtitle2'
                                  color='textSecondary'
                                  gutterBottom
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    fontSize: '0.9rem',
                                    ml: 1,
                                  }}
                                >
                                  <img
                                    src={`${process.env.REACT_APP_IMAGE_URL}/images/${itemPhoto}`}
                                    alt='Uploaded Preview'
                                    style={{
                                      width: '50px',
                                      height: '50px',
                                      marginTop: 8,
                                      borderRadius: '6px',
                                      cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                      setOpenModal(true);
                                      setSelectedImage(itemPhoto);
                                    }}
                                  />
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{ borderBottom: '1px solid #ddd' }} />

                    {/* Item Details and Delivery Quantity Input */}
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        gap: 2,
                        mt: 1,
                        alignItems: 'flex-start',
                      }}
                    >
                      {/* Right Side - Delivery Quantity Input */}
                    </Box>
                    {/* Horizontal Line After Each Item */}
                  </Box>
                );
              })}
            </Box>
          )}

          {/* {file && (
            <Typography
              variant='subtitle2'
              color='textSecondary'
              gutterBottom
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                fontSize: '0.9rem',
                ml: 1,
              }}
            >
              <img
                src={`${process.env.REACT_APP_IMAGE_URL}/images/${file}`}
                alt='Uploaded Preview'
                style={{
                  width: '50px',
                  height: '50px',
                  marginTop: 8,
                  borderRadius: '6px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setOpenModal(true);
                  setSelectedImage(file);
                }}
              />
            </Typography>
          )} */}

          {/* {capturePhoto &&
            (imageUploading ? (
              <CircularProgress size={22} />
            ) : (
              <>
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  // screenshotFormat='image/jpeg'
                  // videoConstraints={{
                  //   width: { ideal: 1920 }, // Reduce resolution to Full HD
                  //   height: { ideal: 1080 },
                  //   facingMode: facingMode,
                  // }}
                  // className='responsive-webcam'
                  screenshotFormat='image/jpeg'
                  videoConstraints={{ facingMode }}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />

                <Box
                  sx={{
                    display: 'flex',
                    gap: 1,
                    mt: 2,
                  }}
                >
                  <Button
                    variant='contained'
                    sx={{
                      textTransform: 'none',
                      p: '0 10px',
                      fontSize: '1rem',
                    }}
                    onClick={handleCapturePhoto}
                  >
                    CAPTURE
                  </Button>
                  <Button
                    variant='contained'
                    sx={{
                      textTransform: 'none',
                      p: '0 10px',
                      fontSize: '1rem',
                    }}
                    onClick={() => {
                      setCapturePhoto(false);
                    }}
                  >
                    CANCEL
                  </Button>
                  <MdFlipCameraIos
                    style={{ marginRight: '5px', cursor: 'pointer' }}
                    fill='#1876D1'
                    onClick={toggleCamera}
                    size={25}
                  />
                </Box>
              </>
            ))} */}

          <Box
            display='flex'
            justifyContent={'space-between'}
            sx={{ mt: 3, gap: 2 }}
          >
            {/* <Box display='flex' gap={1}>
              {selectedDepartment && !capturePhoto && (
                <Button
                  variant='contained'
                  color='error'
                  sx={{
                    textTransform: 'none',
                    p: '2px 10px',
                    fontSize: '1rem',
                  }}
                  onClick={() => setCapturePhoto(true)}
                  disabled={
                    !selectedDepartment ||
                    isEmpty(itemDeliveries) ||
                    imageUploading
                  }
                >
                  TAKE PHOTO
                </Button>
              )}
              {selectedDepartment && (
                <>
                  <input
                    accept='image/*'
                    style={{ display: 'none' }}
                    id='upload-file'
                    type='file'
                    onChange={(e) =>
                      handleFileChange(e?.target?.files?.[0], true)
                    }
                  />
                  <Button
                    component='label'
                    htmlFor='upload-file'
                    variant='contained'
                    sx={{
                      textTransform: 'none',
                      p: '2px 10px',
                      fontSize: '1rem',
                    }}
                    disabled={isEmpty(itemDeliveries) || imageUploading}
                  >
                    <MdOutlineFileUpload size={18} /> UPLOAD
                  </Button>{' '}
                </>
              )}
            </Box> */}

            <Button
              variant='contained'
              color='primary'
              onClick={handleSubmit}
              sx={{ fontSize: 16 }}
              disabled={
                !selectedDepartment ||
                isEmpty(itemDeliveries) ||
                imageUploading ||
                isEmpty(allocations) ||
                loading
              }
              // disabled={isEmpty(file)}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Paper>
      {capturePhoto && (
        <WebcamPopup
          capturePhoto={capturePhoto}
          setCapturePhoto={setCapturePhoto}
          imageUploading={imageUploading}
          facingMode={facingMode}
          setFacingMode={setFacingMode}
          handleCapturePhoto={handleCapturePhoto}
          webcamRef={webcamRef}
        />
      )}
      {openModal && (
        <ImageModal
          open={openModal}
          handleClose={handleCloseModal}
          imageUrl={selectedImage}
        />
      )}
    </Container>
  );
};

export default OutWardItem;

export const WebcamPopup = ({
  capturePhoto,
  setCapturePhoto,
  imageUploading,
  facingMode,
  setFacingMode,
  handleCapturePhoto,
  webcamRef,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const toggleCamera = () => {
    setFacingMode((prev) => (prev === 'user' ? 'environment' : 'user'));
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        bgcolor: 'black',
        zIndex: 2000,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Loading overlay */}
      <Backdrop sx={{ color: '#fff', zIndex: 13000 }} open={imageUploading}>
        <CircularProgress color='inherit' />
      </Backdrop>

      {/* Close button (top-left) */}
      <IconButton
        onClick={() => setCapturePhoto(false)}
        sx={{
          position: 'absolute',
          top: `calc(16px + env(safe-area-inset-top))`,
          left: 16,
          color: 'white',
          zIndex: 2100,
        }}
      >
        <MdClose size={28} />
      </IconButton>

      {/* Camera Feed */}
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%',
          bgcolor: 'black',
          overflow: 'hidden',
        }}
      >
        <Webcam
          ref={webcamRef}
          audio={false}
          screenshotFormat='image/jpeg'
          videoConstraints={{ facingMode }}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transform: facingMode === 'user' ? 'scaleX(-1)' : 'none', // Mirror for front camera
          }}
        />

        {/* Capture Photo button (center bottom) */}
        <IconButton
          onClick={handleCapturePhoto}
          sx={{
            position: 'absolute',
            bottom: `max(100px, calc(40px + env(safe-area-inset-bottom)))`,
            left: '50%',
            transform: 'translateX(-50%)',
            bgcolor: 'white',
            width: 64,
            height: 64,
            borderRadius: '50%',
            zIndex: 10,
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            '&:hover': { bgcolor: '#ddd' },
            WebkitTouchCallout: 'none',
            WebkitUserSelect: 'none',
            '@supports (-webkit-touch-callout: none)': {
              bottom: `calc(100px + env(safe-area-inset-bottom))`,
            },
          }}
        >
          <MdCameraAlt size={32} color='black' />
        </IconButton>

        {/* Flip camera button (bottom-right) */}
        <IconButton
          onClick={() => toggleCamera()}
          sx={{
            position: 'absolute',
            bottom: `max(100px, calc(40px + env(safe-area-inset-bottom)))`,
            right: 32,
            color: 'white',
            bgcolor: 'rgba(0,0,0,0.4)',
            zIndex: 10,
            '&:hover': { bgcolor: 'rgba(0,0,0,0.6)' },
            '@supports (-webkit-touch-callout: none)': {
              bottom: `calc(100px + env(safe-area-inset-bottom))`,
            },
          }}
        >
          <MdFlipCameraAndroid size={32} />
        </IconButton>
      </Box>
    </Box>
  );
};
